import React from 'react'
import './Chart.css'
import chart from '../../img/chart.png'

const Chart = (props) => {
  return (
    <section className="chart-section">
      <div className="container-fluid">

        <h1 className="hard-question-heading">The Hard Question:</h1>

        <div id="chart-div" className="chart-div">

          <div className="why-content">
            <h4>Why has Mississippi Been in</h4>
            <h2 className="last-place-heading">Last Place Since 1929?</h2>
          </div>

          <div>
            <img src={chart} className="chart" alt="chart" />
          </div>

        </div>

      </div>
    </section>
  );
}

export default Chart



/** WEBPACK FOOTER **
 ** ./src/components/home/Chart.js
 **/